export const routes = {
  LANDING: '/',
  TERMINAL: '/terminal',
  AUTH_CALLBACK: '/auth/callback',
  BILLING_SUCCESS: '/billing/success',
  BILLING_CANCEL: '/billing/cancel',
};

export default routes;
